var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('LogInPage',{attrs:{"successRoute":_vm.successRoute}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }